import React from "react";
import Select from "react-select";


import config from "config.json";

function Account({ isReadOnly = false, roleDetails, calcSubRole }) {
  return (
    <div className="field">
      <label className="label">Cargo como treinador</label>
      <Select
        onChange={(evt) => {
          calcSubRole('Treinador', evt.value)
        }}
        isDisabled={isReadOnly}
        value={roleDetails}
        options={config.MANAGER_SUB_ROLES}
      ></Select>
    </div>
  );
}
export default Account;
